

import { Component, Prop, Vue } from 'vue-property-decorator';
import { form4StatusInfoType } from '@/types/Information/Form4';

import StepNumber from "@/components/utils/StepNumber.vue";

@Component({
    components:{
        StepNumber
    }
})
export default class Form4ProcessHeader extends Vue {  
    
    @Prop({required: true})
    stepsCompleted!: form4StatusInfoType;

}
